import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";

export class ProSkillAssureAssessmentSetInfoModel extends Model {
    constructor(
        public trackId: number = 0,
        public trackLevelMapTestTemplateMapCustomAssessmentId: number = 0,
        public setsOrder: number = 0,
        public trackLevelTitle: string = "",
        public trackTitle: string = "",
        public taskCount: number = 0,
        public recommendTime: number = 0
    ) {
        super();
    }

    public static create(model: Partial<ProSkillAssureAssessmentSetInfoModel>): ProSkillAssureAssessmentSetInfoModel {
        return createModel<ProSkillAssureAssessmentSetInfoModel>(ProSkillAssureAssessmentSetInfoModel, {
            ...model
        });
    }
}
